var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9145 10.8017L7.4051 3.20637C7.2051 2.93137 6.79572 2.93137 6.59729 3.20637L1.08635 10.8017C1.07279 10.8204 1.06466 10.8424 1.06287 10.8654C1.06109 10.8885 1.06571 10.9115 1.07623 10.9321C1.08674 10.9526 1.10275 10.9699 1.12246 10.9819C1.14217 10.9939 1.16483 11.0002 1.18791 11.0001H2.35978C2.43947 11.0001 2.51447 10.9611 2.56135 10.897L7.00041 4.77825L11.4395 10.897C11.4863 10.9611 11.5613 11.0001 11.641 11.0001H12.8129C12.9145 11.0001 12.9738 10.8845 12.9145 10.8017Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowIcon);
export default __webpack_public_path__ + "static/media/arrowIcon.c9e4a99c72bf4debb6223ba917bc2928.svg";
export { ForwardRef as ReactComponent };